export default "__VITE_ASSET__d2a83483__"